import { occmClient, apiClient, getCachedClient, handleNetworkResponse } from "utils/clients";
import axios from "axios";
import { setExternals } from "utils/externals";
import { getItemAnon, setItemAnon, setGovCloud } from "utils/localstorage";
import externals from "utils/externals";
import initMfes from "../components/mfe/initMfes";
import _ from "lodash";
import { setFullStoryUserValues, setGAUserProperties } from "utils/ga";
import { getLocalizedValue as t} from "../../../i18n";
import { appComponents as i18nNamespace } from "../../../i18n/namespace";
import { isNcl, isSM3 } from "../../../../src/utils/app/utils";

const HIDE_GTC_COLLECTION_DIALOG_KEY_PREFIX = 'hideGtcCollectionDialog';
const LEARN_MORE_LINK = "https://docs.netapp.com/us-en/console-setup-admin/task-troubleshoot-agent.html";

export default ({ dispatch, getState }) => next => async action => {
    const { type, payload } = action;
    if (type === "APP:BOOT") {

        if (process.env.REACT_APP_IS_SAAS === "true") {
            setExternals({});

            dispatch({
                type: "APP:BOOT-SUCCESS"
            });

            dispatch({
                type: "AUTH:INITIALIZE",
                payload: {
                    domain: process.env.REACT_APP_AUTH0_DOMAIN,
                    clientId: process.env.REACT_APP_AUTH0_CLIENT,
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    testClientId: process.env.REACT_APP_TEST_FEDERATION_APP_AUTH_CLIENT
                }
            });
        } else if (process.env.REACT_APP_IS_AIDP === "true") {
            const { data: supportedServices } = await occmClient.get(process.env.REACT_APP_AIDE_SUPPORT_SERVICE_API_URL);
            let featureFlags = null;
            let featureFlagsNotFound = false;
            try {
                featureFlags = await occmClient.get(process.env.REACT_APP_AIDE_FEATURE_FLAGS_URL, {
                    headers: {
                        'Authorization': `Bearer ${sessionStorage.getItem('ot')}`
                    }
                })
            } catch (e) {
                console.error("Error fetching AIDE feature flags", e);
                if (e.response.status === 401) {
                    dispatch({
                        type: 'AUTH:LOGOUT'
                    });
                } else {
                    featureFlagsNotFound = true;
                }
            }
            if (featureFlags) {
                const features = _.get(featureFlags, 'data.features');
                const metadataEngineVersion = _.get(featureFlags, 'data.status.metadata.version.current');
                dispatch({
                    type: "APP:SUPPORT-SERVICES-SUCCESS",
                    payload: { ...supportedServices, "servicesInformation": { "DataCurator": { "enabled": _.find(features, { name: "inferencing" })?.enabled }, "DataMap": { "enabled": _.find(features, { name: "data_service" })?.enabled } }, "metadataEngineVersion": metadataEngineVersion }
                });
            } else if (featureFlagsNotFound) {
                dispatch({
                    type: "APP:SUPPORT-SERVICES-SUCCESS",
                    payload: { ...supportedServices, "servicesInformation": { "DataCurator": { "enabled": false }, "DataMap": { "enabled": false } }, "metadataEngineVersion": null }
                });
            } else {
                dispatch({
                    type: "APP:SUPPORT-SERVICES-SUCCESS",
                    payload: supportedServices
                });
            }
            dispatch({
                type: 'AUTH:INITIALIZE'
            });
            dispatch({
                type: "APP:BOOT-SUCCESS",
                payload: {
                    accountId: "aidp",
                    clientId: "aidp"
                }
            });
        } else {
            try {
                let supportServiceUrl = "/system/support-services";
                let aboutUrl = "/system/about";
                let instancePlacementUrl = "/system/occm-instance-placement";
                const [{ data: supportedServices }, { data: about }, { data: instancePlacement }] = await Promise.all([occmClient.get(!(isNcl() || isSM3()) ? "/occm/api/occm" + supportServiceUrl : supportServiceUrl),
                    occmClient.get(!(isNcl() || isSM3()) ? "/occm/api/occm" + aboutUrl : aboutUrl),
                    isNcl() ? Promise.resolve({ data: {} }) : occmClient.get(!isSM3() ? "/occm/api/occm" + instancePlacementUrl : '/system/instance-placement')]);
                dispatch({
                    type: "APP:SUPPORT-SERVICES-SUCCESS",
                    payload: supportedServices
                });
                dispatch({
                    type: "APP:ABOUT-SUCCESS",
                    payload: about
                });
                dispatch({
                    type: "APP:INSTANCE-PLACEMENT-SUCCESS",
                    payload: instancePlacement
                });

                if (isNcl()) {
                    setFullStoryUserValues({ 
                        nclEnvironment: about?.environment,
                        nclversion: about?.version,
                        nclReleaseNumber: about?.releaseNumber
                    });
                }

                // Enable the tenancy V2 in case of govCloud deployment
                if (instancePlacement?.govCloud) {
                    setGovCloud(true);
                }
                if (supportedServices.setupInfo && !supportedServices.setupInfo.isSetup && supportedServices.setupInfo.isPendingConnectivitySet) {
                    dispatch({
                        type: "APP:INIT-PROXY"
                    });
                } else {
                    //if there is still not auth0Information, you need to register

                    if (process.env.REACT_APP_IS_DARK !== "true") {

                        const { tenancyServiceInformation: { accountId }, portalService: { auth0Information } } = supportedServices;

                        setExternals({ supportServices: supportedServices, environment: about.environment});

                        if (!auth0Information || !auth0Information.clientId) {
                            try {
                                if (isSM3()) {
                                    await occmClient.post("/bootstrap-agent/v1/agents",
                                        {
                                            type: "application/vnd.netapp.bxp.agent+json",
                                            version: "1.0",
                                        }
                                    );
                                } else {
                                    await occmClient.post("/occm/api/occm/setup-portal/register");
                                }
                                window.location.reload();
                            } catch (e) {
                                if (e.status === 409) {
                                    //CM is already registered
                                    window.location.reload();
                                } else {
                                    dispatch({
                                        type: "APP:BOOT-FAILED",
                                        payload: e
                                    })
                                }
                            }
                        } else {
                            dispatch({
                                type: "AUTH:INITIALIZE",
                                payload: {
                                    domain: auth0Information.domain,
                                    clientId: auth0Information.clientId,
                                    audience: auth0Information.audience,
                                    testClientId: auth0Information.clientId
                                }
                            });
                            if (supportedServices.setupInfo && !supportedServices.setupInfo.isSetup) {
                                dispatch({
                                    type: "APP:INIT-SETUP-WIZARD"
                                });
                            } else if (supportedServices.setupInfo && supportedServices.setupInfo.isSetup && supportedServices.setupInfo.isPendingConnectivitySet) {
                                dispatch({
                                    type: "APP:INIT-PROXY"
                                });
                            } else {
                                dispatch({
                                    type: "APP:GET-AGENT-INFO"
                                });

                                dispatch({
                                    type: "APP:BOOT-SUCCESS",
                                    payload: {
                                        accountId,
                                        clientId: auth0Information?.clientId
                                    }
                                });
                            }
                        }

                    } else {
                        const { tenancyServiceInformation: { accountId } , portalService} = supportedServices;
                        let auth0Information = null;                       
                        if(!isNcl()) {
                            auth0Information = portalService.auth0Information;
                        }
                        
                        setExternals({ supportServices: supportedServices });
                        if (supportedServices.setupInfo && supportedServices.setupInfo.needCertificate) {
                            dispatch({
                                type: "APP:INIT-PROXY"
                            });
                            dispatch({
                                type: "APP:INIT-DARK-SITE-PROXY-SSL-REQUIRED"
                            })
                        } else if (supportedServices.setupInfo && !supportedServices.setupInfo.isSetup) {
                            dispatch({
                                type: "APP:INIT-SETUP-WIZARD"
                            });
                        }
                        else {
                            dispatch({
                                type: 'AUTH:INITIALIZE'
                            });
                            if (supportedServices.setupInfo && supportedServices.setupInfo.isSetup && supportedServices.setupInfo.isPendingConnectivitySet) {
                                dispatch({
                                    type: "APP:INIT-PROXY"
                                });
                            } else {
                                // TODO: Remove check for isNcl once NCL onboarding flow is completed
                                if (!isNcl()) {
                                    dispatch({
                                        type: "APP:GET-AGENT-INFO"
                                    });
                                }
                                dispatch({
                                    type: "APP:BOOT-SUCCESS",
                                    payload: {
                                        accountId,
                                        clientId: auth0Information?.clientId
                                    }
                                });
                            }
                        }
                    }
                }

            } catch (e) {
                console.error("Error during APP:BOOT", e);
                dispatch({
                    type: "APP:BOOT-FAILED",
                    payload: {
                        isLocalUi: "true"
                    }
                });
                dispatch({
                    type: "NOTIFICATIONS:ERROR-WITH-LEARN-MORE-LINK",
                    payload: {
                        message: t("cannot_load_console",i18nNamespace),
                        moreInfo: t("default_error_message", i18nNamespace),
                        hyperLink: LEARN_MORE_LINK,
                        linkText: t("documentation_link_text", i18nNamespace),
                        isFatal: true
                    }
                })
            }
        }
    } else if (type === "APP:HANDLE-GTC-CHECK") {
        const state = getState();
        const { userId } = state.auth;
        const hideGtcCollectionDialog = !!getItemAnon({ itemKey: `${HIDE_GTC_COLLECTION_DIALOG_KEY_PREFIX}_${userId}` });
        if (hideGtcCollectionDialog) {
            dispatch({
                type: "APP:UPDATE-GTC-DATA",
                payload: {
                    showGTCDataCollectionModal: false
                }
            });
        }
        else {
            const { isFederatedUser, isNetAppInternal, email } = state.auth;
            const isNssUser = userId.toLowerCase().includes('|bluexp-federation|');
            if(isFederatedUser && !isNssUser && !isNetAppInternal && !email.endsWith('@netapp.com')) {
                dispatch({
                    type: "APP:GET-GTC-DATA",
                    payload: { userId }
                });
            } else {
                setItemAnon({itemKey: `${HIDE_GTC_COLLECTION_DIALOG_KEY_PREFIX}_${userId}`}, true);
                dispatch({
                    type: "APP:UPDATE-GTC-DATA",
                    payload: {
                        showGTCDataCollectionModal: false
                    }
                });
            }
        }
    } else if (type === "APP:GET-GTC-DATA") {
        const base64UserId = window.btoa(payload.userId);
        apiClient.get(`${process.env.REACT_APP_OCCM_ENDPOINT}/v1/NetApp.identity/users/${base64UserId}`)
            .then(response => {
                const userData = response?.data || {};
                const businessAddress = _.get(userData, 'user_metadata.businessAddress', undefined);
                const userName = _.get(userData, 'name', undefined);
                const userCompany = _.get(userData, 'user_metadata.company', undefined);
                const gtcSubmitted  = _.get(userData, 'app_metadata.gtcSubmitted', false);
                const userCreationTime = new Date(_.get(userData, 'created_at', undefined));
                 //Aug 07 2024 - Federated user data collection for gtc start date
                 const minCreationTime = new Date("08/07/2024");
                const showModalBasedOnDate = userCreationTime > minCreationTime;
                const showGTCDataCollectionModal = showModalBasedOnDate && _.isEmpty(businessAddress) && !gtcSubmitted;

                if (!showGTCDataCollectionModal) {
                    setItemAnon({itemKey: `${HIDE_GTC_COLLECTION_DIALOG_KEY_PREFIX}_${payload.userId}`}, true);
                }

                dispatch({
                    type: "APP:UPDATE-GTC-DATA",
                    payload: {
                        showGTCDataCollectionModal,
                        userName,
                        userCompany
                    }
                });
            })
            .catch(error => {
                console.error(error);
                dispatch({ type: "APP:GET-GTC-DATA-FAILED" });
            });
    } else if (type === "APP:SAVE-GTC-DATA") {
        const base64UserId = window.btoa(payload.userId);
        const formData = payload.formData;
        apiClient.put(`${process.env.REACT_APP_OCCM_ENDPOINT}/v1/NetApp.identity/compliancecheck/${base64UserId}`, formData)
            .then((result) => {
                setItemAnon({itemKey: `${HIDE_GTC_COLLECTION_DIALOG_KEY_PREFIX}_${payload.userId}`}, true);
                dispatch({ type: "APP:SAVE-GTC-DATA-SUCCESS" });
                dispatch({
                    type: "APP:UPDATE-GTC-DATA",
                    payload: {
                        showGTCDataCollectionModal: false
                    }
                });
            }).catch((error) => {
                console.error(error);
                dispatch({
                    type: "APP:SAVE-GTC-DATA-FAILED",
                    payload: { error }
                });
            });
    } else if (type === "APP:LOAD-SERVICES") {
        let p;
        if (process.env.REACT_APP_SERVICES_ARRAY_ENDPOINT) {
            const isUserOnTheNewDomain = window.location.origin === process.env.REACT_APP_SAAS_FRONTEND;

            const oldEndpoint = process.env.REACT_APP_SERVICES_ARRAY_ENDPOINT;
            const newEndpoint = `${window.location.origin}/services`;

            const endPoint = isUserOnTheNewDomain ? newEndpoint : oldEndpoint;

            p = Promise.all([
                axios.get(`${endPoint}/services.json`).then(({ data }) => data),
                axios.get(`${endPoint}/nav.json`).then(({ data }) => data)
            ]);
        } else {
            p = Promise.all([
                import("ui-services/build/services").then(module => module.default),
                import("ui-services/build/nav").then(module => module.default)
            ])
        }

        try {
            let [services, navJson] = await p;

            dispatch({
                type: "APP:LOAD-SERVICES-SUCCESS",
                payload: {
                    services,
                    navJson
                }
            })
            
        } catch (e) {
            dispatch({
                type: "APP:LOAD-SERVICES-ERROR",
                payload: e
            })
        }
    } else if (type === "APP:GET-AGENT-INFO") {
        try {
            const { data: about } = await occmClient.get(isSM3() ? "/system/about" : "/occm/api/occm/system/about");
            dispatch({
                type: "APP:GET-AGENT-INFO-SUCCESS",
                payload: about
            })
        } catch (err) {
            dispatch({
                type: "APP:GET-AGENT-INFO-FAILED",
                payload: err
            })
        }

    } else if (type === "APP:INITIALIZE-FEATURES") {
        const { supportServices, servicesList, instancePlacement } = getState().app;
        const isRestricted = getState()?.tenancy?.selectedAccount?.isSaas === false;
        const isGovCloud = instancePlacement?.govCloud === true;
        setExternals({ servicesList, supportServices });

        dispatch({
            type: "FEATURES:INITIALIZE",
            payload: {
                services: servicesList,
                supportServices: supportServices,
                isRestricted,
                isGovCloud
            }
        })
        dispatch({
            type: "APP:LOAD-SERVICE-INTEGRATION-PATH",
            payload: {
                services: servicesList,
                activeFeatures: getState().features.active
            }
        });

        const mfeServices = [];
        servicesList.forEach(service => {
            if(_.has(service, ['uiIntegration', 'stageIntegrations'])) {
                service?.uiIntegration.stageIntegrations.forEach(stageIntegration => {
                    
                    const { endpointId, isEsmModule, renderType } = stageIntegration;
                    if(renderType === "mfe/v1") {                        
                        let mfeService = {
                            name: stageIntegration.scope,
                            entry: externals.serviceMfes[endpointId]
                        }
                        if (isEsmModule) {
                            mfeService.type = 'module';
                        }
                        if(mfeService.entry){
                             mfeServices.push(mfeService)

                        }

                       
                    }
                })
            }
        });

        if(!_.isEmpty(mfeServices)) {
             // Init all the Mfes
            dispatch({
                type: "APP:LOAD-MFE-SERVICES",
                payload: {
                    mfeServices
                }
            });
            initMfes(mfeServices);
        }
      
    } else if (type === "MENU:INITIALIZE") {
        const state = getState();
        const { active: activeFeatures } = state.features;
        const { servicesByNewKey, navJson, instancePlacement } = state.app;
        const { isDemo } = state.tenancy;

        action.payload = {
            activeFeatures,
            servicesByNewKey,
            navJson,
            installLocation: instancePlacement?.installLocation?.toLowerCase(),
            isDemo
        }
    } else if (type === "APP:BOOT-FAILED" || type === "APP:LOAD-SERVICES-ERROR") {
        if (!payload.isLocalUi){
            dispatch({
                type: "NOTIFICATIONS:ERROR",
                payload: {
                    message: t("failed_to_initialize_ui",i18nNamespace),
                    exception: payload,
                    isFatal: true
                }
            })
        }
    } else if (type === "SUPPORT:ADD-NSS-OPEN-POPOVER") {
        /**
         * Note: Most lazy loading occurs based on routes, but since services can dispatch to Add NSS even before having been to support dashboard, we will also lazy load on this action
         */
        const state = getState();
        if (!state.support) {
            import('modules/support' /* webpackChunkName: "Support"*/).then(r => {
                dispatch(action);
            })
            return next({ type: "IGNORE" });
        }
    } else if (type === "APP/RELOAD") {
        window.location.reload();
    } else if (type === "APP:FETCH-BROWNFIELD-DETAILS") {
        const { selectedOrgId, ignoreCache = false } = payload;
        if (selectedOrgId) {
           dispatch({ type: 'APP:FETCH-BROWNFIELD-DETAILS-LOADING' });
           const handleResponse = (serverResponse, { dispatch }) => {
                    const { data: { items }} = serverResponse;
                    const brownfieldResource = items?.[0] || null;
                    const isBrownFieldUser = !!brownfieldResource || false;
                    dispatch({
                        type: "APP:FETCH-BROWNFIELD-DETAILS-SUCCESS",
                        payload: {isBrownFieldUser, brownfieldResource}
                    });
                    //set analytics user properties
                    setFullStoryUserValues({ brownfieldUser: isBrownFieldUser ? 'Yes' : 'No' });
                    setGAUserProperties({ brownfieldUser: isBrownFieldUser ? 'Yes' : 'No' });
            };

            const handleError = (error, { dispatch }) => {
                    console.error("Error fetching storage details:", error);
                    dispatch({
                        type: "APP:FETCH-BROWNFIELD-DETAILS-ERROR",
                      });
            }
            try {
                const brownfieldResourceFilter = isNcl()
                    ? "((resourceClass eq 'ON_PREM' and resourceType eq 'ON_PREM') or (resourceClass eq 'STORAGE_SERVICES' and (resourceType eq 'ESERIES' or resourceType eq 'SG')))"
                    : "((resourceClass eq 'VSA') or (resourceClass eq 'ON_PREM' and resourceType eq 'ON_PREM'))";
                const { response , networkResponse } = await getCachedClient(apiClient, `${externals.tenancyV4Backend}/organizations/${selectedOrgId}/resources?filter=${brownfieldResourceFilter}&limit=1`, 'fetch-brownfield-details-'+selectedOrgId, undefined, ignoreCache);
                handleResponse(response, { dispatch });
                handleNetworkResponse(networkResponse, handleResponse, handleError, { dispatch })
            } catch (error) {
                handleError(error, {dispatch})
            }
        } else {
            dispatch({
                type: "APP:FETCH-BROWNFIELD-DETAILS-ERROR",
            });
        }
    } else if (type === "GALLERY:DELETE-WORKING-ENVIRONMENT-COMPLETE") {
        // Removing the last system has to flip the home page back to greenfield, so the
        // brownfield lookup is repeated against the network instead of the cached result.
        const selectedOrgId = getState().tenancy?.selectedOrgId;
        if (selectedOrgId) {
            dispatch({
                type: "APP:FETCH-BROWNFIELD-DETAILS",
                payload: {
                    selectedOrgId,
                    ignoreCache: true
                }
            });
        }
    } else if (type === "FEATURE-MANAGER:FETCH-FEATURES-BY-ORG") {
        dispatch({ type: "FEATURE-MANAGER: FETCH-FEATURES-BY-ORG-REQUEST" });
        const handleResponse = (response, { dispatch, organizationId }) => {
            const transformedFeatures = response.data?.items?.map(feature => ({
                key: `NetApp.FeatureManager/${feature.name}`,
                title: feature.tags?.[0]?.displayName || feature.name,
                active: feature.status === 'ACTIVE',
                alwaysOn: feature.status === 'ACTIVE',
                description: feature.description,
                organizationIds: feature.organizationIds || [],
                ownerId: feature.contributors?.[0],
                rolloutPercentage: feature.rolloutPercentage || 0,
                createdAt: feature.createdAt,
                updatedAt: feature.updatedAt
            })) || [];            

            dispatch({
                type: "FEATURE-MANAGER: FETCH-FEATURES-BY-ORG-SUCCESS",
                payload: {
                    organizationId: organizationId,
                    features: transformedFeatures,
                    originalData: response.data
                }
            });

            dispatch({
                type: "TENANCYV4:UPDATE-ROLES-BY-FEATURE-MANAGER"
            });

            dispatch({
                type: "FEATURE-MANAGER:UPDATE-NAVITEMS-BY-FEATURE-MANAGER",
                payload: {
                    activeFeatures: getState().features.active
                }
            });
        }
        const handleError = (error, {dispatch}) => {
                console.error("Error fetching features by organization:", error);
                dispatch({
                    type: "FEATURE-MANAGER: FETCH-FEATURES-BY-ORG-FAILURE",
                    payload: {
                        error: error.message || t("failed_to_fetch_features_by_org", i18nNamespace)
                    }
                });
        }
        try {
            const { organizationId } = payload;
            const {response, networkResponse} = await getCachedClient(apiClient, `${externals.stargateV4Backend}/feature-rollouts?organizationId=${organizationId}`, `fetch-features-by-org-${organizationId}`);
            handleResponse(response, {dispatch, organizationId});
            handleNetworkResponse(networkResponse, handleResponse, handleError, {dispatch, organizationId})
        } catch (error) {
            handleError(error,{dispatch});
        }

    } else if (type === "APP:RELOAD-SUPPORT-SERVICES") {
        const supportServiceUrl = "/system/support-services";
        try {
            const { data: supportedServices } = await occmClient.get(supportServiceUrl);
            dispatch({
                type: "APP:SUPPORT-SERVICES-SUCCESS",
                payload: supportedServices
            });
            setExternals({ supportServices: supportedServices });
        } catch (e) {
            console.error("Error reloading support services", e);
            dispatch({
                type: "APP:RELOAD-SUPPORT-SERVICES-FAILED",
                payload: e
            });
        }
    }

    return next(action);

}
